var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAchievementCategory(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 8.75222L17.0934 5.77055C16.9717 5.64639 16.8342 5.53555 16.6675 5.45805L10.6675 2.64639C10.2467 2.45055 9.75337 2.45055 9.33254 2.64639L3.33254 5.45805C3.16587 5.53555 3.02837 5.64639 2.90671 5.77055L10 8.75222ZM9.37504 9.85572L2.50004 6.96572V13.4066C2.49587 13.9407 2.81587 14.4307 3.32504 14.6716L9.32504 17.4824C9.33314 17.4862 9.34167 17.4888 9.3503 17.4913L9.35031 17.4913C9.35856 17.4938 9.3669 17.4962 9.37504 17.4999V9.85572ZM10.625 17.4974V9.85572L17.5 6.96572V13.4141C17.5 13.9466 17.1775 14.4341 16.6675 14.6716L10.6675 17.4824C10.66 17.4862 10.6519 17.4886 10.6438 17.4911C10.6375 17.4929 10.6312 17.4949 10.625 17.4974Z",
    fill: "#B0B3C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchievementCategory);
export default __webpack_public_path__ + "static/media/achievementCategory.0cc51ee7894e824d8bf51a7b775fcddc.svg";
export { ForwardRef as ReactComponent };